import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';
import { AuthService } from '@bayclubs/horizon';

const HORIZON_RETURN_URL_KEY = 'horizon.auth.returnUrl';

export const authGuard: CanActivateFn = (route, state) => {
    const authService = inject(AuthService);
    if (!authService.isAuthenticated()) {
        // AuthService.navigateAfterLogin() reads sessionStorage[HORIZON_RETURN_URL_KEY].
        // MsalGuard does not write it, so without this a deep link lands on the default
        // route after the Azure AD round trip.
        sessionStorage.setItem(HORIZON_RETURN_URL_KEY, state.url);
    }
    return inject(MsalGuard).canActivate(route, state);
};
